const PricePublisherMixin = require('../../modules/mixins/price_publisher.mixin');
const addMembership = require('od-modules/helpers/membership/add_membership');
const {getMembershipType} = require('od-modules/utils/membership_utils');
const {getMembershipSubscriptionOffer} = require('od-modules/helpers/membership/service.api');

const isFreeTrial = () => Odigeo.Membership.isMembershipFreeTrial || Odigeo.Membership.isPrimeMobile;

module.exports = Odigeo.Model.extend(PricePublisherMixin.extend({
    defaults: {
        member: {},
        allPrice: 0,
        allPriceFromBackend: isFreeTrial() ? null : 0,
        onePrice: 0,
        onePriceFromBackend: 0,
        quantity: 0,
        conceptKey: 'membershipsubscription',
        conceptLabel: '',
        type: 'MEMBERSHIP_SUBSCRIPTION',
        memberSelected: null,
        isUserLoggedIn: false,
        userDTO: null,
        isPriceWithoutDiscountSelected: false,
        state: '',
        scenario: '',
        membershipPriceIsZero: false,
        membershipType: '',
    },

    getOfferFromResponse(response) {
        const offer = response.membershipSubscriptionOfferDTO;
        return Odigeo._.isObject(offer) && Odigeo._.isEmpty(response.errors) ? offer : {price: 0};
    },

    checkIfOfferIsZero(offer) {
        this.set('membershipPriceIsZero', offer.price === 0);
        return offer;
    },

    buildPriceFromOffer(offer) {
        return {
            ...offer,
            onePriceFromBackend: +offer.price,
            allPriceFromBackend: +offer.price,
            formattedPrice: Odigeo.Utils.formatCurrency(offer.price, Odigeo._.extend({}, Odigeo.Utils.Currency, {decimalPlaces: 2})),
        };
    },

    setMembershipType() {
        const membershipType = getMembershipType();
        this.set('membershipType', membershipType);
    },

    propagate(widgetId, offer) {
        Odigeo.trigger(`${widgetId}:membershipSubscriptionStored`, offer.formattedPrice);
    },

    init() {
        this.bindEvents();
        this.fetchProductPrice(this.widget.id);
    },

    bindEvents() {
        this.on('change:quantity', Odigeo._.bind(this.onQuantityChange, this));
    },

    refreshData() {
        this.isEmptyData = false;
        this.refresh();
    },

    updateProduct(action, isUserLoggedIn) {
        const removeAction = this.isRemoveAction(action);
        const quantity = removeAction ? 0 : 1;
        const membershipProduct = this.getMembershipProduct(quantity);
        const {password, memberSelected, allPriceFromBackend, onePriceFromBackend} = membershipProduct;
        const data = {
            allPrice: removeAction ? 0 : allPriceFromBackend,
            onePrice: removeAction ? 0 : onePriceFromBackend,
            isUserLoggedIn: !!isUserLoggedIn,
            memberSelected,
            password,
            quantity,
        };
        this.set(data);
        addMembership.updateMembershipProduct(membershipProduct);
    },

    removeAndAddProduct() {
        this.set({quantity: 0}, {silent: true});
        this.updateProduct('add');
    },

    isRemoveAction(action) {
        return action === 'remove';
    },

    onQuantityChange(model) {
        this.addItemToPricemanagerCollection(model.attributes);
        Odigeo.trigger(`${this.widget.id}:membershipSubscriptionChange`, model.attributes);
    },

    fetchProductPrice(widgetId) {
        getMembershipSubscriptionOffer().then((response) => {
            let offer = this.getOfferFromResponse(response);
            offer = this.buildPriceFromOffer(offer);
            this.setMembershipType();
            this.checkIfOfferIsZero(offer);
            this.propagate(widgetId, offer);
            this.set({...offer});
        });
    },

    isProductStoredInSession() {
        const oldRequest = this.getCurrentOrOldProduct();
        return !Odigeo._.isEmpty(oldRequest) && oldRequest.quantity > 0;
    },

    getOldProductRequest() {
        const membershipProductPreviousRequest = Odigeo.Utils.parseJson(Odigeo.Session.get('membershipProductPreviousRequest'));
        return !Odigeo._.isNull(membershipProductPreviousRequest) ? membershipProductPreviousRequest : {};
    },

    setListOfTravellers(data) {
        const {email, isLogged, password, status, travellers} = data;
        this.set('member', {
            email,
            isLogged,
            password,
            status,
            travellers,
        });
    },

    getNameAndLastName(existsMember, memberSelected) {
        return existsMember ? Odigeo._.find(this.get('member').travellers, function(it) {
            return it.id === memberSelected;
        }, this) : {name: '', lastName: ''};
    },

    getMemberSelectedFromPreviousRequest() {
        const oldRequest = this.getOldProductRequest();
        return !Odigeo._.isEmpty(oldRequest) && !!oldRequest.memberSelected ? oldRequest.memberSelected : null;
    },

    getMemberSelected() {
        const memberSelected = this.get('memberSelected');
        return !Odigeo._.isNull(memberSelected) ? memberSelected : this.getMemberSelectedFromPreviousRequest();
    },

    isMemberSelected() {
        return !!this.isProductStoredInSession() || !!this.get('memberSelected');
    },

    getData() {
        const memberSelected = this.getMemberSelected();
        const existsMember = !Odigeo._.isEmpty(this.get('member')) && !Odigeo._.isEmpty(memberSelected);
        const nameAndLastName = this.getNameAndLastName(existsMember, memberSelected);
        return {
            password: existsMember ? this.get('password') : '',
            quantity: this.get('quantity'),
            name: nameAndLastName.name,
            lastName: nameAndLastName.lastName,
            memberSelected: memberSelected,
            allPriceFromBackend: this.get('allPriceFromBackend'),
            onePriceFromBackend: this.get('onePriceFromBackend'),
        };
    },

    getMembershipProduct(quantity) {
        let data = {};
        if (quantity > 0) {
            const membershipProduct = this.getCurrentOrOldProduct();
            data = this.getDataProduct(this.getData(), membershipProduct);
            const email = Odigeo._.isEmpty(this.get('member').email) ? membershipProduct.email : this.get('member').email;
            Odigeo._.merge(data, {email});
        }
        Odigeo._.merge(data, {quantity});
        return data;
    },

    getDataProduct(data, oldProductRequest) {
        const password = Odigeo._.isEmpty(data.password) ? oldProductRequest.password : data.password;
        const name = Odigeo._.isEmpty(data.name) ? oldProductRequest.name : data.name;
        const lastName = Odigeo._.isEmpty(data.lastName) ? oldProductRequest.lastName : data.lastName;
        const memberSelected = Odigeo._.isEmpty(data.memberSelected) ? oldProductRequest.memberSelected : data.memberSelected;
        const allPriceFromBackend = this.isPriceEmpty(data.allPriceFromBackend) ? oldProductRequest.allPriceFromBackend : data.allPriceFromBackend;
        const onePriceFromBackend = this.isPriceEmpty(data.onePriceFromBackend) ? oldProductRequest.onePriceFromBackend : data.onePriceFromBackend;
        return {name, lastName, password, memberSelected, allPriceFromBackend, onePriceFromBackend};
    },

    getCurrentOrOldProduct() {
        const newProductRequest = Odigeo.Utils.parseJson(Odigeo.Session.get('newMembershipProduct'));
        return !Odigeo._.isNull(newProductRequest) ? newProductRequest : this.getOldProductRequest();
    },

    isPriceEmpty(price) {
        if (isFreeTrial()) {
            return price === null;
        } else {
            return price === null || price === undefined || price === 0;
        }
    },
}));
